import React, { useState, useEffect } from 'react'
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
  CircularProgress,
  Autocomplete,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Alert,
  AlertTitle,
  Switch,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Chip,
  Divider,
  Tooltip
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import SaveIcon from '@mui/icons-material/Save';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchIcon from '@mui/icons-material/Search';
import { alpha } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { getRequest, postRequest } from '../../../globalhelper/helper'
import _ from 'lodash';


const BillExtract = ["Bill", "SubseqDr", "SubseqCr"]

const GoodsAndServicesEntries = ["GoodsReceipt", "ServiceReceipt", "ReversalGoodsReceipt", "ReversalServiceReceipt", "ReturnGoodsReceipt", "ReturnServiceReceipt", "GoodsIssue", "ServiceIssue", "InternalTransferReceipt", "InternalTransferIssue", "GoodsReceiptDirectCapitalization", "GoodsReceiptCWIP", "GoodsConsumption"]

const BillExtract_GoodsAndServicesEntries = {
  "Bill": "close",
  "SubseqDr": "close",
  "SubseqCr": "close",
  "GoodsReceipt": "close",
  "ServiceReceipt": "close",
  "ReversalGoodsReceipt": "close",
  "ReversalServiceReceipt": "close",
  "ReturnGoodsReceipt": "close",
  "ReturnServiceReceipt": "close",
  "GoodsIssue": "close",
  "ServiceIssue": "close",
  "InternalTransferReceipt": "close",
  "InternalTransferIssue": "close",
  "GoodsReceiptDirectCapitalization": "close",
  "GoodsReceiptCWIP": "close",
  "GoodsConsumption": "close"
}


function Book_Closure() {
  const [Companies, setCompanies] = useState([])
  const [Company, setCompany] = useState(null)
  const [selectedDate, setSelectedDate] = useState(moment())

  const [DisplayRecord, setDisplayRecord] = useState(null)
  const [warn, set_warn] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    getRequest(`api/veranda/getCompany0`)
      .then(res => {
        if (res.type === "success") {
          let data = JSON.parse(res.res.data)
          data = _.sortBy(data, "orgname")
          setCompanies(data)
        }
      })
  }, [])

  const getBookClosureRecord = () => {
    set_warn(null)
    setDisplayRecord(null)
    setLoading(true)

    const selectedYearString = selectedDate.format('YYYY')
    const selectedMonthString = selectedDate.format('MM')

    getRequest(`api/vr2/getBookClosureRecord?Company=${Company?.orgid}&Year=${selectedYearString}&Month=${selectedMonthString}`)
      .then(res => {
        setLoading(false)
        if (res.res.status === "success") {
          let DATA = res.res.data
          set_warn({ severity: 'info', title: 'Modifying Existing', message: 'You are modifying an existing record.' })
          setDisplayRecord(DATA)
        }
        else {
          set_warn({ severity: 'success', title: 'Creating New', message: 'You are creating a new record.' })
          setDisplayRecord(BillExtract_GoodsAndServicesEntries)
        }
      })
      .catch(() => {
        setLoading(false)
        set_warn({ severity: 'error', title: 'Error', message: 'Failed to fetch the book closure record.' })
      })
  }


  const handleDateChange = (newValue) => {
    setSelectedDate(newValue)
  }

  const onStatusChange = (val, key) => {
    setDisplayRecord(prev => {
      const next = { ...prev };
      next[key] = val;
      return next;
    });
  }

  const keys_BillExtract = DisplayRecord ? Object.keys(DisplayRecord).filter(k => BillExtract.includes(k)) : [];
  const keys_GoodsServices = DisplayRecord ? Object.keys(DisplayRecord).filter(k => GoodsAndServicesEntries.includes(k)) : [];

  const handleToggleAll = (keys, status) => {
    setDisplayRecord(prev => {
      const next = { ...prev };
      keys.forEach(key => {
        next[key] = status;
      });
      return next;
    });
  }

  const saveBookClosureRecord = () => {
    const selectedYearString = selectedDate.format('YYYY')
    const selectedMonthString = selectedDate.format('MM')

    postRequest(`api/vr2/saveBookClosureRecord?Company=${Company?.orgid}&Year=${selectedYearString}&Month=${selectedMonthString}`, DisplayRecord)
      .then(res => {
        if (res.res.status === "success") {
          Reset()
        }
      })
  }

  const Reset = () => {
    setSelectedDate(moment());
    set_warn(null);
    setDisplayRecord(null);
  };
  const renderHeaderButtons = keys => <Box sx={{
    display: 'flex',
    gap: 1
  }}>
    <Button size="small" startIcon={<DoneAllIcon />} onClick={e => {
      e.stopPropagation();
      handleToggleAll(keys, 'open');
    }} sx={{
      fontSize: '0.65rem',
      textTransform: 'none',
      color: 'success.main'
    }}>
      Open All
    </Button>
    <Button size="small" startIcon={<RemoveDoneIcon />} onClick={e => {
      e.stopPropagation();
      handleToggleAll(keys, 'close');
    }} sx={{
      fontSize: '0.65rem',
      textTransform: 'none',
      color: 'error.main'
    }}>
      Close All
    </Button>
  </Box>;
  const renderTable = keys => <TableContainer sx={{
    overflow: 'hidden'
  }}>
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          {(keys && keys.length > 0 ? Object.keys(keys[0] || {}) : []).map((key, index) => <TableCell key={index} sx={{
            textAlign: 'left'
          }}><b>{key}</b></TableCell>)}
        </TableRow>
      </TableHead>
      <TableBody>
        {(keys || []).map((row, rowIndex) => <TableRow key={rowIndex}>
          {Object.entries(row || {}).map(([key, val], valIndex) => {
            let displayVal = val;
            if (typeof val === 'number' && !Number.isInteger(val)) {
              displayVal = val.toFixed(2);
            } else if (typeof val === 'string' && !isNaN(val) && val.trim() !== '' && val.includes('.')) {
              displayVal = parseFloat(val).toFixed(2);
            } else if (typeof val === 'boolean') {
              displayVal = val ? 'Yes' : 'No';
            } else if (val === null || val === undefined) {
              displayVal = '';
            } else if (typeof val === 'object') {
              displayVal = JSON.stringify(val);
            }
            return <TableCell key={valIndex} sx={{
              textAlign: 'left'
            }}>
              {String(displayVal)}
            </TableCell>;
          })}
        </TableRow>)}
      </TableBody>
    </Table>
  </TableContainer>;
  return <LocalizationProvider dateAdapter={AdapterMoment}>
    <Box sx={{
      minHeight: '100vh',
      bgcolor: '#f8fafc',
      position: 'relative'
    }}>
      <Container maxWidth="xl" sx={{
        py: 4,
        pb: 12
      }}>
        <Box sx={{
          mb: 4
        }}>
          <Typography variant="h5" sx={{
            color: '#475569',
            fontWeight: 800,
            mb: 1,
            letterSpacing: '-0.02em'
          }}>
            Book Closure Management
          </Typography>
          <Typography variant="body2" sx={{
            color: '#64748b'
          }}>
            Configure open/closed document types for monthly accounting periods.
          </Typography>
        </Box>

        <Paper elevation={0} sx={{
          p: 2.5,
          mb: 3,
          borderRadius: 3,
          border: '1px solid #e2e8f0',
          bgcolor: '#ffffff'
        }}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={5}>
              <Autocomplete options={Companies} getOptionLabel={option => `${option.orgname} (${option.orgid})`} value={Company} onChange={(event, newValue) => setCompany(newValue)} disabled={Boolean(DisplayRecord)} renderInput={params => <TextField {...params} label="Company" variant="standard" fullWidth />} />
            </Grid>

            <Grid item xs={12} md={3}>
              <DatePicker views={['year', 'month']} label="Accounting Period" minDate={moment('2022-01-01')} maxDate={moment().add(1, 'year')} value={selectedDate} onChange={handleDateChange} disabled={Boolean(DisplayRecord)} renderInput={params => <TextField {...params} variant="standard" fullWidth />} />
            </Grid>

            <Grid item xs={12} md={4}>
              <Box sx={{
                display: 'flex',
                gap: 1.5,
                justifyContent: {
                  xs: 'center',
                  md: 'flex-end'
                }
              }}>
                <Button variant="contained" startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <SearchIcon />} disabled={!Company || !selectedDate || loading} onClick={getBookClosureRecord} sx={{
                  bgcolor: '#475569',
                  textTransform: 'none',
                  px: 3,
                  '&:hover': {
                    bgcolor: '#334155'
                  },
                  borderRadius: 2
                }}>
                  Retrieve
                </Button>
                <Button variant="text" startIcon={<RefreshIcon />} onClick={Reset} sx={{
                  color: '#64748b',
                  textTransform: 'none'
                }}>
                  Reset
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Paper>

        {warn && <Box sx={{
          mb: 3
        }}>
          <Alert severity={warn.severity} sx={{
            borderRadius: 2,
            border: '1px solid',
            borderColor: alpha(warn.severity === 'info' ? '#3b82f6' : warn.severity === 'success' ? '#22c55e' : '#ef4444', 0.1)
          }}>
            <AlertTitle sx={{
              fontSize: '0.85rem',
              fontWeight: 700
            }}>{warn.title}</AlertTitle>
            <Typography variant="caption">{warn.message}</Typography>
          </Alert>
        </Box>}

        {DisplayRecord && <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2
        }}>
          {/* Bill Extract Section */}
          <Accordion defaultExpanded elevation={0} sx={{
            borderRadius: '12px !important',
            border: '1px solid #e2e8f0',
            '&:before': {
              display: 'none'
            }
          }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                pr: 2
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }}>
                  <Typography sx={{
                    fontWeight: 700,
                    color: '#475569',
                    fontSize: '0.95rem'
                  }}>Bill Extract</Typography>
                  <Chip label={`${keys_BillExtract.filter(k => DisplayRecord[k] === 'open').length}/${keys_BillExtract.length} Open`} size="small" sx={{
                    fontSize: '0.65rem',
                    height: 20,
                    bgcolor: alpha('#22c55e', 0.1),
                    color: '#166534',
                    fontWeight: 700
                  }} />
                </Box>
                {renderHeaderButtons(keys_BillExtract)}
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{
              pt: 0
            }}>
              {renderTable(keys_BillExtract)}
            </AccordionDetails>
          </Accordion>

          {/* Goods And Services Entries Section */}
          <Accordion defaultExpanded elevation={0} sx={{
            borderRadius: '12px !important',
            border: '1px solid #e2e8f0',
            '&:before': {
              display: 'none'
            }
          }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%',
                pr: 2
              }}>
                <Box sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2
                }}>
                  <Typography sx={{
                    fontWeight: 700,
                    color: '#475569',
                    fontSize: '0.95rem'
                  }}>Goods & Services Entries</Typography>
                  <Chip label={`${keys_GoodsServices.filter(k => DisplayRecord[k] === 'open').length}/${keys_GoodsServices.length} Open`} size="small" sx={{
                    fontSize: '0.65rem',
                    height: 20,
                    bgcolor: alpha('#22c55e', 0.1),
                    color: '#166534',
                    fontWeight: 700
                  }} />
                </Box>
                {renderHeaderButtons(keys_GoodsServices)}
              </Box>
            </AccordionSummary>
            <AccordionDetails sx={{
              pt: 0
            }}>
              {renderTable(keys_GoodsServices)}
            </AccordionDetails>
          </Accordion>
        </Box>}
      </Container>

      {/* Sticky Footer */}
      {DisplayRecord && <Box sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: alpha('#ffffff', 0.8),
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid #e2e8f0',
        py: 2,
        px: 4,
        display: 'flex',
        justifyContent: 'center',
        zIndex: 1100,
        boxShadow: '0 -4px 20px rgba(0,0,0,0.03)'
      }}>
        <Button variant="contained" size="large" onClick={saveBookClosureRecord} startIcon={<SaveIcon />} sx={{
          minWidth: 280,
          bgcolor: '#475569',
          '&:hover': {
            bgcolor: '#334155'
          },
          fontWeight: 700,
          borderRadius: 2.5,
          textTransform: 'none',
          py: 1.2
        }}>
          Save Book Closure Changes
        </Button>
      </Box>}
    </Box>
  </LocalizationProvider>;
}

export default Book_Closure;